<form [formGroup]="form">
  @if (isArrayItem()) {
    <glxy-form-row>
      <glxy-form-field class="col-xs-12 col-sm-2" bottomSpacing="none" [hideRequiredLabel]="true">
        <mat-select formControlName="type">
          @for (option of parameterTypeOptions; track option.value) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </glxy-form-field>
      <glxy-form-field class="col-xs-12 col-sm-9" bottomSpacing="none" [hideRequiredLabel]="true">
        <input
          type="text"
          matInput
          formControlName="description"
          placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.PARAMETER.DESCRIPTION_PLACEHOLDER' | translate }}"
        />
      </glxy-form-field>
      <button mat-icon-button class="col-xs-12 col-sm-1" (click)="remove.emit()" [disabled]="disableDelete()">
        <mat-icon>close</mat-icon>
      </button>
    </glxy-form-row>
  } @else {
    <glxy-form-row>
      <glxy-form-field class="col-xs-12 col-sm-3" bottomSpacing="none" [hideRequiredLabel]="true">
        <input
          type="text"
          matInput
          formControlName="name"
          placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.PARAMETER.KEY_PLACEHOLDER' | translate }}"
        />
      </glxy-form-field>
      <glxy-form-field class="col-xs-12 col-sm-2" bottomSpacing="none" [hideRequiredLabel]="true">
        <mat-select formControlName="type">
          @for (option of parameterTypeOptions; track option.value) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </glxy-form-field>
      <glxy-form-field class="col-xs-12 col-sm-6" bottomSpacing="none" [hideRequiredLabel]="true">
        <input
          type="text"
          matInput
          formControlName="description"
          placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.PARAMETER.DESCRIPTION_PLACEHOLDER' | translate }}"
        />
      </glxy-form-field>
      <button mat-icon-button class="col-xs-12 col-sm-1" (click)="remove.emit()" [disabled]="disableDelete()">
        <mat-icon>close</mat-icon>
      </button>
    </glxy-form-row>
  }

  @if (type?.value === ParameterType.OBJECT || type?.value === ParameterType.ARRAY) {
    <cdk-accordion>
      <cdk-accordion-item #accordionItem="cdkAccordionItem">
        <div class="accordion">
          <p (click)="accordionItem.toggle()" class="object-fields">
            <mat-icon class="expand-icon">{{ accordionItem.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            @if (type.value === ParameterType.OBJECT) {
              {{ name?.value }} {{ 'AI_ASSISTANT.FUNCTIONS.PARAMETER.FIELDS' | translate }}
            } @else {
              {{ name?.value }} array items
            }
          </p>
        </div>
        @if (accordionItem.expanded) {
          @if (type.value === ParameterType.OBJECT) {
            <div class="fields-container" formArrayName="properties">
              @if (properties.length === 0) {
                <mat-card class="empty">
                  <mat-card-content>
                    {{ 'AI_ASSISTANT.FUNCTIONS.PARAMETER.NO_FIELDS' | translate: { name: name?.value } }}
                  </mat-card-content>
                </mat-card>
              } @else {
                @for (property of properties.controls; let i = $index; track property) {
                  <ai-function-parameter class="inner-parameter" [formControl]="property" (remove)="removeField(i)">
                  </ai-function-parameter>
                }
              }
            </div>
            <button
              mat-button
              color="primary"
              type="button"
              class="add-field"
              (click)="addField({ type: ParameterType.STRING })"
            >
              {{
                name?.value
                  ? ('AI_ASSISTANT.FUNCTIONS.PARAMETER.ADD_FIELD_TO' | translate: { name: name?.value })
                  : ('AI_ASSISTANT.FUNCTIONS.PARAMETER.ADD_FIELD_NO_NAME' | translate)
              }}
            </button>
          } @else {
            <div class="fields-container">
              <ai-function-parameter
                class="inner-parameter"
                formControlName="items"
                [disableDelete]="true"
                [isArrayItem]="true"
              >
              </ai-function-parameter>
            </div>
          }
        }
      </cdk-accordion-item>
    </cdk-accordion>
  }
</form>
